module.exports = __webpack_public_path__ + "static/media/input-check.636ecad7.svg";